/**
 * TSS logs Admin API
 * TSS logs Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { MetaDataSummaryDTO } from '../model/models';
import { TenantTssConfigBodyDTO } from '../model/models';
import { TenantTssConfigResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetMetaDataSummaryByTssIdRequestParams {
    tssId: string;
}

export class ClsGetMetaDataSummaryByTssIdRequestParams {
    tssId: string = undefined;
}

export interface GetTenantTssConfigRequestParams {
    tenantId: string;
}

export class ClsGetTenantTssConfigRequestParams {
    tenantId: string = undefined;
}

export interface UpdateTenantTssConfigRequestParams {
    tenantId: string;
    tenantTssConfigBodyDTO: TenantTssConfigBodyDTO;
}

export class ClsUpdateTenantTssConfigRequestParams {
    tenantId: string = undefined;
    tenantTssConfigBodyDTO: TenantTssConfigBodyDTO = undefined;
}


export interface AdminApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get a specific MetaDataSummary object by tss id
     * Get meta data summary entity by tss id
* @param requestParameters
     */
    getMetaDataSummaryByTssId(requestParameters: GetMetaDataSummaryByTssIdRequestParams, extraHttpRequestParams?: any): Observable<MetaDataSummaryDTO>;

    /**
     * Get tenant TSS config
     * Get tenant TSS configuration from TSS cloud DB.
* @param requestParameters
     */
    getTenantTssConfig(requestParameters: GetTenantTssConfigRequestParams, extraHttpRequestParams?: any): Observable<TenantTssConfigResponseDTO>;

    /**
     * Update tenant TSS config
     * Get tenant TSS configuration from TSS cloud DB.
* @param requestParameters
     */
    updateTenantTssConfig(requestParameters: UpdateTenantTssConfigRequestParams, extraHttpRequestParams?: any): Observable<TenantTssConfigResponseDTO>;

}
